// First we need to import axios.js
import axios from "axios";
// Next we make an 'instance' of it
const instance = axios.create({
  //baseURL: "http://localhost:80/iranwushufed/api/sanda/",
  baseURL: "https://iranwushufed.ir/api/sanda2/",
});

export default instance;
